import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Variante } from 'app/models/variante.models';

@Component({
  selector: 'app-componente-dialogo',
  template: `
    <div class="container" style="padding: 30px;">
    <h2 mat-dialog-title>{{ data.titulo }}</h2>
    <mat-dialog-content>
      <form [formGroup]="form">
      <div class="form-group">
              <label>Variante componente</label>
              <select class="form-select" formControlName="componentVariantId">
                <option value="" disabled>Seleccione una variante</option>
                <option *ngFor="let variante of data.variantes" [value]="variante.id">
                  {{ variante.name }} ({{ variante.article?.name }})
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Cantidad</label>
              <input type="number" class="form-control" formControlName="quantity" min="1" />
            </div>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="cancelar()">Cancelar</button>
      <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="guardar()">
        Agregar Componente
      </button>
    </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .form-group {
      margin-bottom: 15px;
      width: 100%;
    }`]
})
export class ComponenteDialogoComponent {
  form: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<ComponenteDialogoComponent>,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: {
      titulo: string;
      variantes: Variante[];
      componente?: any;
    }
  ) {
    this.form = this.fb.group({
      componentVariantId: ['', Validators.required],
      quantity: [1, [Validators.required, Validators.min(1)]]
    });

    // Si estamos editando un componente existente, cargamos sus datos
    if (data.componente) {
      this.form.patchValue({
        componentVariantId: data.componente.componentVariantId,
        quantity: data.componente.quantity
      });
    }
  }

  cancelar(): void {
    this.dialogRef.close();
  }

  guardar(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }
}